let service = function (Http) {
	"ngInject";
	this.get = (id) => Http.get('/v1/category-group/'+id, true);
	this.all = () => Http.get('/v1/category-group', true);
};

export default service;




// WEBPACK FOOTER //
// ./app/shared/services/categoryGroup.service.js